import Alert, { AlertColor } from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Snackbar from '@mui/material/Snackbar';
import React from 'react';
// import { makeStyles, Theme, createStyles } from '@mui/styles';
import ReactDOM from 'react-dom';

import styled from 'styled-components';

const StyledSnackbar = styled(Snackbar)`
    .MuiAlert-icon {
        width: 40px;
        height: 40px;
    }
    .MuiAlert-filledError {
        border-radius: 16px;
        background: rgba(212, 64, 69, 0.9);

        & .muialert-action {
            align-items: flex-start;
            padding-top: 8px;
        }
    }
    .MuiAlert-filledInfo {
        border-radius: 16px;
        background: #3563f3;
        & .MuiAlert-message {
            color: #060816;
        }
    }
    .MuiAlert-filledWarning {
        border-radius: 16px;
        background: #edad3f;
    }
    .MuiAlert-filledSuccess {
        border-radius: 16px;
        background: #3563f3;
        & .MuiAlert-message a {
            font-weight: 600;
            color: #060816;
            line-height: 17px;

            &:hover {
                text-decoration: none;
            }
        }
    }
    .MuiButtonBase-root {
        color: #fff;
    }

    .MuiAlertTitle-root {
        font-size: 20px;
        line-height: 22px;
    }

    .errorText {
        color: #fff;
    }
`;

interface Props {
    type?: AlertColor | 'loading';
    isOpen: boolean;
    title?: string;
    text: string | React.ReactNode;
    onClose(): void;
    key?: string;
    duration?: number;
    anchorOrigin?: {
        vertical: 'top' | 'bottom';
        horizontal: 'center' | 'left' | 'right';
    };
}

export default function CustomAlert({
    type = 'success',
    title,
    text,
    isOpen = false,
    key = 'global-alert',
    onClose,
    duration = 3000,
    anchorOrigin = {
        vertical: 'bottom',
        horizontal: 'center',
    },
}: Props) {
    // const classes = useStyles();

    return ReactDOM.createPortal(
        <StyledSnackbar
            // className={classes.root}
            open={isOpen}
            autoHideDuration={duration}
            key="global-alert"
            onClose={onClose}
            anchorOrigin={anchorOrigin}
            ClickAwayListenerProps={{
                mouseEvent: false,
            }}
        >
            <Alert
                elevation={6}
                variant="filled"
                onClose={onClose}
                severity={type === 'loading' ? 'warning' : type}
            >
                {title && <AlertTitle>{title}</AlertTitle>}
                <div className="errorText">{text}</div>
            </Alert>
        </StyledSnackbar>,
        document.body,
    );
}
